import { signal } from '@preact/signals';
import type { TabType, ToastNotification } from '../types/common';

export const activeTabSignal = signal<TabType>('tab-messages');
export const highlightedMessageIdSignal = signal<string | null>(null);
export const isNavigatingToMessageSignal = signal<boolean>(false);
export const navigationOverlayTextSignal = signal<string>('Localizando mensagem de origem e preparando o chat...');
export const isGeminiModalOpenSignal = signal<boolean>(false);
export const isAddContactModalOpenSignal = signal<boolean>(false);
export const isAiChatDrawerOpenSignal = signal<boolean>(false);
export const aiDrawerWidthSignal = signal<number>(
  parseInt(typeof localStorage !== 'undefined' ? localStorage.getItem('alfred_chat_drawer_width') || '384' : '384', 10)
);
export const toastsSignal = signal<ToastNotification[]>([]);

export function showToast(message: string, type: 'success' | 'error' | 'info' = 'success') {
  const id = Math.random().toString(36).substring(2, 9);
  const newToast: ToastNotification = { id, message, type };
  toastsSignal.value = [...toastsSignal.value, newToast];

  setTimeout(() => {
    removeToast(id);
  }, 3500);
}

export function removeToast(id: string) {
  toastsSignal.value = toastsSignal.value.filter(t => t.id !== id);
}

export function setAiDrawerWidth(width: number) {
  const clamped = Math.round(Math.max(300, Math.min(width, 900)));
  aiDrawerWidthSignal.value = clamped;
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('alfred_chat_drawer_width', String(clamped));
  }
}
